"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AVERAGE = void 0;
const tab_1 = require("../../../tab");
exports.AVERAGE = {
    description: 'Returns the average of the values of a set of numbers',
    arg_names: ['number...'],
    args_def: [
        {
            types: ['number'],
            required: true,
            variadic: true,
        },
    ],
    args_description: [
        'Any number, or reference to a cell containing a number, that you want to find the average of. Any field that is not a number or empty will be ignored',
    ],
    return_type: tab_1.ColumnType.NUMBER,
};
